import { API } from '@/config';
import ShCard from '@/components/Helpers/ShCard';
import ShButton from '@/components/Helpers/ShButton';
import HintAndExplanation from '@/components/Common/HintAndExplanation';

// @vue/component
export default {
  name: 'ClientData',

  components: {
    ShCard,
    ShButton,
    HintAndExplanation,
  },

  props: {
    client: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      editableClient: null,
      isLoading: false,
      editDisabled: false,
      shouldShowHint: true,
      formEmailForInvoices: {
        email_address_for_invoices: null,
      },
      validationEmailInvoicesRules: {
        email: { required: true, validator: this.emailValidator, trigger: 'blur' },
      },
      validationRules: {
        company_name: { required: true, message: 'Pole jest wymagane', trigger: 'blur' },
        company_address: { required: true, message: 'Pole jest wymagane', trigger: 'blur' },
        company_postal_code: [
          { required: true, message: 'Pole jest wymagane', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('Pole jest wymagane'));
            }

            if (value && (value.match(/\d+/g).join('')).length !== 5) {
              callback(new Error('Nieprawidłowe dane'));
            }

            callback();
          },
          trigger: 'blur' },
        ],
        company_city: { required: true, message: 'Pole jest wymagane', trigger: 'blur' },
        company_nip: [
          { validator: (rule, value, callback) => {
            if (value && (value.match(/\d+/g).join('')).length !== 10) {
              callback(new Error('Nieprawidłowe dane'));
            }
            callback();
          },
          trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    isPrepaid() {
      // eslint-disable-next-line camelcase
      return this.user?.access?.account_type === 'prepaid';
    },
    isEmailInvoiceSending() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'access/update',
      ]);
    },
  },

  created() {
    this.editDisabled = this.$store.getters['authorization/hasRequiredAccountData'];
    this.editableClient = this.client ? this.client : {};
    this.shouldShowHint = !this.$store.getters['authorization/hasRequiredAccountData'];
    this.formEmailForInvoices.email_address_for_invoices = this.$store.getters['authorization/user'].access.email_address_for_invoices;
  },

  methods: {
    emailValidator(rule, value, callback) {
      if (!this.formEmailForInvoices.email_address_for_invoices) {
        callback(new Error('Adres e-mail jest wymagany'));
      }
      // eslint-disable-next-line no-useless-escape
      if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(this.formEmailForInvoices.email_address_for_invoices)) {
        callback(new Error('Nieprawidłowy adres e-mail'));
      }
      callback();
    },
    handleChangeEmailForInvoices() {
      this.$refs.formEmailForInvoices.validate(async (isValid) => {
        if (isValid) {
          this.$store.dispatch('access/update', this.formEmailForInvoices);
          this.$notify.success({
            title: 'Adres e-mail, na który otrzymasz fakturę',
            message: 'Dane zapisane poprawnie',
            customClass: 'callmeweb-notification',
          });
        }
      });
    },
    handleAddOrEditClientData() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          this.isLoading = true;
          await API.post('/account', this.editableClient);
          this.isLoading = false;
          this.$notify.success({
            title: 'Dane Klienta',
            message: 'Dane zapisane poprawnie',
            customClass: 'callmeweb-notification',
          });
          this.$store.dispatch('authorization/checkIfUserSessionExists', { endpoint: '/authorization/checkIfUserSessionExist' });
          this.shouldShowHint = false;
          this.editDisabled = true;
        }
      });
    },
  },
};
